<template>
  <section id="table-inspection" v-if="tableData">
    <div class="task-table">
      {{ $t('report_tasks.table') }} - {{ tableData.question }} ({{
        tableData.tableRow
      }}
      x
      {{ tableData.tableColumn }})
    </div>
    <div id="image-container">
      <ImageWithErrorFallback
        v-if="getImageUrl"
        :imageUrl="getImageUrl"
        class="table-image"
      />
    </div>
    <b-table :data="tableQuestionData.data" :striped="true">
      <template slot-scope="props">
        <b-table-column
          v-for="(column, index) in tableQuestionData.columns"
          :key="index"
          :label="column.label"
        >
          <DisplayRichTextEditor
            v-if="typeof props.row[column.field] === 'string'"
            :value="props.row[column.field]"
          />
          <DisplayRichTextEditor
            v-else
            :value="props.row[column.field].value"
          />
          <b-field
            v-if="
              (props.row[column.field].lastUpdatedBy ||
                props.row[column.field].lastModifiedAt) &&
              !isCustomerReport
            "
          >
            <b-tag v-if="props.row[column.field].lastUpdatedBy">{{
              props.row[column.field].lastUpdatedBy
            }}</b-tag>
            <b-tag v-if="props.row[column.field].lastModifiedAt">{{
              parseDate(props.row[column.field].lastModifiedAt)
            }}</b-tag>
          </b-field>
        </b-table-column>
      </template>
    </b-table>
  </section>
</template>

<script>
import ImageWithErrorFallback from '../components/ImageWithErrorFallback';
import DisplayRichTextEditor from '../../../components/RichTextEditor/DisplayRichTextEditor';

export default {
  name: 'TableInspection',
  props: {
    tableData: {
      type: Object,
      required: true,
    },
  },
  components: {
    ImageWithErrorFallback,
    DisplayRichTextEditor,
  },
  computed: {
    isCustomerReport() {
      return !this.$store.getters['ReportsModule/isInternalReport'];
    },
    tableQuestionData() {
      const columns = [];
      const { tableData } = this;
      tableData.tableData[0].forEach((item, index) => {
        columns.push({
          field: index.toString(),
          label: item,
        });
      });
      const data = [];
      for (let i = 1; i < tableData.tableData.length; i++) {
        const row = tableData.tableData[i].map((item, index) => {
          const cell = {};
          cell[columns[index].field] = item;
          return cell;
        });
        data.push(
          row.reduce((prev, curr) => {
            return { ...prev, ...curr };
          })
        );
      }

      return {
        data,
        columns,
      };
    },
    getImageUrl() {
      if (!this.tableData.tableImg || this.tableData.tableImg === '') {
        return null;
      }
      const imageUrl = this.tableData.tableImg;

      if (window.location.host.includes('localhost')) {
        return `http://localhost:4566/images${imageUrl}`;
      }

      return imageUrl;
    },
  },

  methods: {
    parseDate(date) {
      if (date instanceof Date) {
        const parsedDate = new Date(date);
        return parsedDate.toLocaleDateString();
      }

      if (date) {
        return new Date(date).toLocaleDateString();
      }
      return '-';
    },
  },
};
</script>

<style scoped lang="scss">
.task-table {
  width: 100%;
}

#image-container {
  display: flex;
  justify-content: center;
}

.table-image {
  border: #ccc 1px solid;
}
</style>
